export default {
  namespaced: true,
  state:{    
    professionalInsurances: [],    
    professionalInsuranceCreate: {
      modal: false,
      values: {}
    },
    professionalInsuranceEdit: {
      modal: false,
      values: {}
    }
  },
  getters:{
    professionalInsurances(state){
      return state.professionalInsurances;
    },   
    professionalInsuranceCreate(state) {
        return state.professionalInsuranceCreate;
    },
    professionalInsuranceEdit(state) {
      return state.professionalInsuranceEdit;
    }    
  },
  mutations:{
    SET_PROFESSIONAL_INSURANCES(state, values){
      state.professionalInsurances = values;
    },
    SET_PROFESSIONAL_INSURANCE_CREATE_MODAL(state, value) {
      state.professionalInsuranceCreate.modal = value;
    },
    SET_PROFESSIONAL_INSURANCE_CREATE_VALUES(state, value) {
      state.professionalInsuranceCreate.values = value;
    },
    SET_PROFESSIONAL_INSURANCE_EDIT_MODAL(state, value) {
      state.professionalInsuranceEdit.modal = value;
    },
    SET_PROFESSIONAL_INSURANCE_EDIT_VALUES(state, value) {
      state.professionalInsuranceEdit.values = value;
    },
    PUSH_PROFESSIONAL_INSURANCE(state, value){
      state.professionalInsurances.push(value);
    },    
    SET_UPDATE_PROFESSIONAL_INSURANCE(state, values){
      var editedIndex = state.professionalInsurances.map(professionalInsurance => professionalInsurance.id).indexOf(values.id);      
      if (editedIndex > -1){
        Object.assign(state.professionalInsurances[editedIndex], values);              
      }
      return;
    },
    SPLICE_PROFESSIONAL_INSURANCE(state, value){
      let i = state.professionalInsurances.map(professionalInsurance => professionalInsurance.id).indexOf(value);      
      state.professionalInsurances.splice(i, 1);
    }
  },
  actions:{
    getProfessionalInsurances({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/professional-insurances').then((response) => {
          commit('SET_PROFESSIONAL_INSURANCES', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    professionalInsuranceStore({commit}, payload) {
      const formData = new FormData();
      for(var key in payload) {
          formData.append(key, payload[key]);
      }
      return new Promise((resolve, reject) => {
        axios.post('admin/professional-insurances', formData).then((response) => {
          commit('PUSH_PROFESSIONAL_INSURANCE', response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    professionalInsuranceUpdate({commit}, payload) {
      var value = payload.id;            
      return new Promise((resolve, reject) => {
        axios.put('admin/professional-insurances/' + value, payload).then((response) => {          
          commit('SET_UPDATE_PROFESSIONAL_INSURANCE', response.data.data);
          resolve(response);   
        })
        .catch((error) => {
          reject(error);
        })
      });
    },
    deleteProfessionalInsurance({ commit }, value) {
      return new Promise((resolve, reject) => {
        axios.delete('admin/professional-insurances/' + value).then((response) => {
          commit('SPLICE_PROFESSIONAL_INSURANCE', value);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
      });      
    },
  }
}
